import React from "react";
import projImg1 from "../../assets/img/SF23.jpg";
import { Link } from "react-router-dom";

export const Silverfort = () => {
  return (
    <>
      <h1 style={{ textAlign: "center", marginTop: "150px" }}>Silverfort</h1>
      <div className="product-Big">
        <div className="InCenter">
          <p>
            Silverfort is a unified identity protection platform that extends Multi-Factor Authentication (MFA) 
            and Zero Trust access to any resource, including legacy systems, command-line tools, and
             service accounts. It helps organizations prevent identity-based attacks by enforcing adaptive 
             access policies across both cloud and on-premises environments without requiring agents or proxies.
          </p>
          <Link to="/Silverfort">
          <button className="custom-button">
              <span>
              Read More
              </span>
           </button>
          </Link>
        </div>
         <div>
          <img src={projImg1} alt="Silverfort" />
        </div>
      </div>
    </>
  );
};
